import i18n from "@/i18n";

export const backgroundsFields = [
    {
        key: "name",
        label: i18n.t("background.colBackgroundName"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "actions",
        label: ""
    },
    {
        key: "drag",
        label: "",
        class: "draggable-btn-cell"
    }
];
